module.exports = __webpack_public_path__ + "img/logo-pyse.21e1d39a.png";